import { Box, Typography } from '@gapartners/ui';
import type { CustomerInfoHeaderProps } from './types';

export function CustomerInfoHeader({ t }: CustomerInfoHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Typography variant="subtitle2" fontWeight={600} color="text.primary">
        {t('components.contactCenter.customerInfo')}
      </Typography>
    </Box>
  );
}
